var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLeftArrow = function SvgIcLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4829 18.5047L2.60124 10.5919C2.28972 10.2804 2.28972 9.75078 2.60124 9.40811L10.5452 1.46416C10.8879 1.15264 10.919 0.623047 10.6075 0.280371C10.4517 0.093457 10.2337 0 9.98444 0C9.73522 0 9.51714 0.093457 9.36138 0.280371L9.17446 0.467285L0.233643 9.43926C-0.0778809 9.75078 -0.0778809 10.2804 0.233643 10.623L9.36138 19.7508C9.51714 19.9065 9.70405 20 9.92212 20C10.3894 20 10.7633 19.6262 10.7633 19.19C10.7944 18.9096 10.6698 18.6604 10.4829 18.5047Z"
  })));
};
export default SvgIcLeftArrow;